import { combineReducers } from '@reduxjs/toolkit'

import { actionHintsReducer, baseApi, connectionReducer, liveReducer, maintenanceReducer, sessionReducer, windowsReducer } from '@krp/client-runtime'

import { aqsiModule, duplicatesModule, oneCModule, ownModule, platformModule, receiptsModule, scheduleModule, syncModule } from '../composition/modules'
import { themeReducer } from './theme'

/**
 * Корень состояния. Форма RootState видна ТОЛЬКО в приложении: пакеты её не
 * импортируют даже как тип (D-051). RootState выводится из rootReducer, а не из
 * store.getState — иначе циклический вывод типов (CLAUDE.md §7).
 */
export const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  session: sessionReducer,
  live: liveReducer,
  connection: connectionReducer,
  maintenance: maintenanceReducer,
  windows: windowsReducer,
  actionHints: actionHintsReducer,
  platform: platformModule.reducer,
  onec: oneCModule.reducer,
  aqsi: aqsiModule.reducer,
  own: ownModule.reducer,
  receipts: receiptsModule.reducer,
  duplicates: duplicatesModule.reducer,
  sync: syncModule.reducer,
  schedule: scheduleModule.reducer,
  theme: themeReducer,
})

export type RootState = ReturnType<typeof rootReducer>
